import { render, staticRenderFns } from "./AppsDropDown.vue?vue&type=template&id=54a3e152&scoped=true&"
import script from "./AppsDropDown.vue?vue&type=script&lang=js&"
export * from "./AppsDropDown.vue?vue&type=script&lang=js&"
import style0 from "./AppsDropDown.vue?vue&type=style&index=0&id=54a3e152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3e152",
  null
  
)

export default component.exports